<template>
  <div class="col-md-12">

    <div class="alert alert-danger">
        <i class="fa fa-info-circle mr-2"></i>
        <span> {{ $t('attentionnote') }} </span>
    </div>

    <div class="row">
      <el-table :data="transferOptions" v-if="selectedCurrency == 'eur'" style="width: 100%" >
        <el-table-column :label="txt.options_bank_name">
          <span slot-scope="scope">
            {{ scope.row.bank_name }}
          </span>
        </el-table-column>

        <el-table-column :label="txt.options_beneficiary">
          <span slot-scope="scope">
            {{ scope.row.beneficiary }}
          </span>
        </el-table-column>

        <el-table-column :label="txt.options_iban">
          <span slot-scope="scope">
            {{ scope.row.IBAN }}
          </span>
        </el-table-column>

        <el-table-column :label="txt.options_swift">
          <span slot-scope="scope">
            {{ scope.row.SWIFT }}
          </span>
        </el-table-column>

        <el-table-column :label="txt.options_address" width="280px">
          <div class="col-md-12" slot-scope="scope">
            <div v-for="row in scope.row.address" class="row">
              <span>{{ row }}</span>
            </div>
          </div>
        </el-table-column>
      </el-table>

      <el-table :data="transferOptions" v-if="selectedCurrency == 'usd'"  style="width: 100%">
        <el-table-column :label="txt.options_bank_name">
          <span slot-scope="scope">
            {{ scope.row.bank_name }}
          </span>
        </el-table-column>

        <el-table-column :label="txt.options_accountHolder" min-width="100">
          <span slot-scope="scope">
            {{ scope.row.beneficiary }}
          </span>
        </el-table-column>

        <el-table-column :label="txt.options_routingNumber" min-width="100">
          <span slot-scope="scope">
            {{ scope.row.routingNumber }}
          </span>
        </el-table-column>

        <el-table-column :label="txt.options_swiftBic" min-width="100">
          <span slot-scope="scope">
            {{ scope.row.swiftBic }}
          </span>
        </el-table-column>

        <el-table-column :label="txt.options_accountNumber" min-width="100">
          <span slot-scope="scope">
            {{ scope.row.accountNumber }}
          </span>
        </el-table-column>

        <el-table-column :label="txt.option_type">
          <span slot-scope="scope">
            {{ scope.row.accountType }}
          </span>
        </el-table-column>

        <el-table-column :label="txt.options_address" width="240">
        <div class="col-md-12" slot-scope="scope">
          <div v-for="row in scope.row.address" class="row">
            <span>{{ row }}</span>
          </div>
        </div>
      </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>

export default {
  name: "transferMethod",
  props: {
    selectedCurrency: {type: String, default: ''},
  },
  data() {
    return {
      txt: {
        options: this.$t('optionstxt'),
        options_bank_name: this.$t('bankname'),
        options_beneficiary: this.$t('beneficiary'),
        options_iban: this.$t('iban'),
        options_swift: this.$t('swift'),
        options_address: this.$t('address'),
        options_accountHolder: this.$t('accountHolder'),
        options_accountNumber: this.$t('accountNumber'),
        options_accountType: this.$t('accountType'),
        options_routingNumber: this.$t('routingNumber'),
        options_swiftBic: "SWIFT/BIC",
        option_type: this.$t('type'),
      },
      transferOptions: [],
      optionsList: [
          {
            currency: 'eur',
            transferOptions: [
              {
                "bank_name": "TransferWise",
                "beneficiary": "Caprico Ltd",
                "IBAN": "BE13 9671 1361 3739",
                "SWIFT": "TRWIBEB1XXX",
                "address": ["TransferWise Europe", "SA Avenue Marnix 13-17 1000", "Brussels, Belgium"]
              }
            ],
          },
          {
            currency: 'usd',
            transferOptions: [
              {
                "bank_name": "Local ACH",
                "beneficiary": "Caprico Ltd",
                "routingNumber": "026073150",
                "accountNumber": "8312005801",
                "swiftBic": "-",
                "accountType": "Checking",
                "address": ["Wise's address", "30 W. 26th Street, Sixth Floor, New York NY 10010", "New York, United States"],
                "cost": "4.14 HKO",
              },
              {
                "bank_name": "Global - SWIFT",
                "beneficiary": "Caprico Ltd",
                "routingNumber": "026073150",
                "swiftBic": "CMFGUS33",
                "accountNumber": "8312005801",
                "accountType": "Checking",
                "address": ["Wise's address", "30 W. 26th Street, Sixth Floor, New York NY 10010", "New York, United States"],
                "cost": "4.14 HKO",
              },
            ]
          },
        ]
    }
  },
  created() {
    let optionsByCurrency = this.optionsList.find( el => el.currency == this.selectedCurrency )
    this.transferOptions = optionsByCurrency.transferOptions
  }
}
</script>
<style scoped>

</style>
